import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=0f835d6b&"
import script from "./LanguagesList.vue?vue&type=script&lang=js&"
export * from "./LanguagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports